export default __webpack_public_path__ + "static/media/Ch2b.0c08f839.gif";